import React, { useEffect } from "react";
// import Logo from '../Assets/Images/logo_hdfc.png';
import { useSelector, useDispatch } from "react-redux";
import { setSendSMS, resetCarState } from "../Redux/Features/carSlice";
import { persistor, store, resetAppState } from "../Redux/store";
import { useTelemetry } from "../telemetry/TelemetryProvider";


const Thank = () => {
  const breakin = useSelector((state) => state.breakin);
  const dispatch = useDispatch();
  const car = useSelector((state) => state.car);
  const isClaim = useSelector((state) => state.isClaim);
  const isUploadLater = useSelector((state) => state.isUploadLater);
  let sourceApp = localStorage.getItem("ls_source");

  const { track, tSessionId } = useTelemetry();

  useEffect(() => {
    if (isUploadLater) {
      track("THANK_YOU_LOADED", {
        message: "Will upload later in network",
      });
    } else if (isClaim) {
      track("THANK_YOU_LOADED", {
        message: "Claim thank you page loaded",
      });
    } else {
      track("THANK_YOU_LOADED", {
        message: "Breakin thank you page loaded",
      });
    }
  }, []);

  // Effect to handle SMS opening
  useEffect(() => {

    if (!car.sms && !isClaim) {
      setTimeout(() => {
        dispatch(setSendSMS());
        window.open(`https://api.whatsapp.com/send?phone=918169500500`);
      }, 2000);
    }
  }, []);

  const clearLocalStorageExceptSource = () => {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key !== "ls_source" && key !== "ref_num") {
        localStorage.removeItem(key);
      }
    }
  };

  // Enhanced effect to clear Redux state on component mount
  useEffect(() => {

    const clearReduxState = async () => {
      try {
        // First reset the Redux state using our action
        dispatch(resetAppState());
        // Short delay to allow state updates to process
        await new Promise((resolve) => setTimeout(resolve, 50));

        // Then flush any pending persist operations
        await persistor.flush();

        // Then purge the persisted state
        await persistor.purge();

        // Additional step: manually update the slice states if needed
        dispatch(resetCarState());

        // Explicitly remove the Redux persist item from session storage
        sessionStorage.removeItem("persist:user");

        // Clear all storage for good measure
        sessionStorage.clear();
        clearLocalStorageExceptSource();

        // Final check - see what's in session storage after clearing
        const remainingItems = Object.keys(sessionStorage);
        if (remainingItems.length > 0) {
          console.warn(
            "Items still in session storage after clearing:",
            remainingItems
          );

          // Force clear again with a delay
          setTimeout(() => {
            sessionStorage.clear();
          }, 100);
        }
      } catch (error) {
        console.error("Error clearing Redux state:", error);
      }
    };

    // Execute the clearing function
    if (!isUploadLater) {
      clearReduxState();
    }
    // Clean up function that runs when component unmounts
    return () => {
      // One final clear attempt on unmount
      sessionStorage.clear();
      clearLocalStorageExceptSource();
    };
  }, [dispatch]); // Add dispatch to dependency array


  if (isUploadLater) {
    return (
      <section className="success_container">
        <img src="/logo_hdfc.png" alt="hdfc-ergo" />
        <p id="thankyou_txt">
          Images are <b>NOT SUBMITTED</b> yet.
        </p>
        <p id="success_para">
          Please revisit the link when you are back in network to complete the
          upload process.
        </p>
      </section>
    );
  } else if (sourceApp == "WAPC_MOBAPPS") {
    return (
      <section className="success_container">
        <img src="/logo_hdfc.png" alt="hdfc-ergo" />
        <p className="claim_mainpara">Thank You</p>
        <p className="claim_subpara">
          Your inspection photos have been submitted successfully.
          <br />
          <br />
          Our AI system is now reviewing them — this usually takes about 5
          minutes. <br />
          <br />
          Please wait for the assessment to appear on the{" "}
          <span className="color-red">Point of Impact screen</span>.<br />
          <br />
          The results will also be automatically updated in the Computation
          Sheet, so make sure to review them before proceeding to the next step.
        </p>
      </section>
    );
  } else if (isClaim) {
    return (
      <section className="success_container">
        <img src="/logo_hdfc.png" alt="hdfc-ergo" />
        <p id="thankyou_txt">
          Thank You, your claim is submitted for processing.
        </p>
      </section>
    );
  } else {
    return (
      <section className="success_container">
        <img src="/logo_hdfc.png" alt="hdfc-ergo" />
        <p id="thankyou_txt">Thank You.</p>
        <p id="success_para">
          You have successfully submitted the required photographs. We will
          review and get back to you within 1 hour.
        </p>
      </section>
    );
  }
};

export default Thank;
